import { render, staticRenderFns } from "./StoreDeletionModal.vue?vue&type=template&id=fb352806&scoped=true"
import script from "./StoreDeletionModal.vue?vue&type=script&lang=ts"
export * from "./StoreDeletionModal.vue?vue&type=script&lang=ts"
import style0 from "./StoreDeletionModal.vue?vue&type=style&index=0&id=fb352806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb352806",
  null
  
)

export default component.exports